// src/shared/components/dashboard/CollapsibleSection.tsx
// ────────────────────────────────────────────────────────────────────────────
// Collapsible section with toggle — single source of truth for expandable
// sections in cards and dashboards.
// ────────────────────────────────────────────────────────────────────────────
import React, { memo, useState } from 'react';

export interface CollapsibleSectionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  count?: number;
}

function CollapsibleSection({ title, children, defaultOpen = true, count }: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-t border-white/[0.04]">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between px-3 py-1.5
                   text-[10px] text-neutral-500 uppercase tracking-wider
                   hover:text-neutral-400 transition-colors"
      >
        <span>{title}{count != null ? ` (${count})` : ''}</span>
        <span className="text-neutral-600">{open ? '▾' : '▸'}</span>
      </button>
      {open && <div className="px-3 pb-2.5">{children}</div>}
    </div>
  );
}

export default memo(CollapsibleSection);
